import Swal, { type SweetAlertIcon, type SweetAlertOptions } from 'sweetalert2'
import i18n from '@/plugins/i18n.js'

export const createSwal = async ({
  icon = '',
  title = '',
  confirmColor = '#2196F3',
  cancelColor = '#f53535',
  text = '',
  html = '',
  closeable = true,
  confirmButtonText = i18n.global.t('generics.ok'),
  cancelButtonText = i18n.global.t('generics.cancel'),
  isRtl = false,
  direction = 'ltr',
  showCancelButton = true,
}) => {
  if (!direction) direction = isRtl ? 'rtl' : 'ltr'

  const resolvedTitle = title
    ? `<p style="direction: ${direction} !important;">${title}</p>`
    : ''
  const resolvedHtml = html
    ? `<p style="direction: ${direction} !important;">${html}</p>`
    : text
      ? `<p style="direction: ${direction} !important;">${text}</p>`
      : ''
  return await Swal.fire({
    title: resolvedTitle,
    html: resolvedHtml,
    icon: icon as SweetAlertIcon,
    confirmButtonText,
    confirmButtonColor: confirmColor,
    showCancelButton,
    cancelButtonText,
    cancelButtonColor: cancelColor,
    allowOutsideClick: closeable,
    customClass: 'v-application',
  } as SweetAlertOptions)
}

export const timeoutSwal = ({
  icon = 'success',
  title = '',
  text = '',
  lang = 'he',
  timer = 1500,
}) => {
  let direction = lang === 'en' ? 'ltr' : 'rtl'
  if (icon === 'error' && !title) {
    title = 'Error'
  }

  return Swal.fire({
    icon: icon as SweetAlertIcon,
    title: `<p style="direction: ${direction} !important;">${title}</p>`,
    html: text
      ? `<p style="direction: ${direction} !important;">${text}</p>`
      : '',
    showCancelButton: false,
    showConfirmButton: false,
    timer,
    allowOutsideClick: false,
    position: 'center',
    customClass: 'v-application',
  } as SweetAlertOptions)
}

export const createCheckbox = async ({
  text = '',
  html = '',
  title = '',
  icon = 'warning',
  inputPlaceholder = '',
  confirmButtonText = 'OK',
}) =>
  Swal.fire({
    icon: icon as SweetAlertIcon,
    title,
    text,
    html,
    input: 'checkbox',
    inputValue: 1,
    inputPlaceholder,
    confirmButtonText,
  })
